/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ChatBoardDetail from "../../../../app/modules/Chat/Component/ChatBoard/ChatBoardDetail";
import { AppString } from "../../../../app/modules/Chat/Component/Const";
import { myFirestore } from "../../../../app/modules/Chat/Config/firebase";

export function StickyToolbar(props) {
  const [currentPeerUser, setPerCurrentUsers] = useState([]);
  const [listUsersFirebase, setListUsersFirebase] = useState([]);
  const [userId, setUserId] = useState(null);
  const [currentPeerItem, setPeerItem] = useState(null);

  async function getListUserFirebase() {
    const result = await myFirestore.collection(AppString.NODE_USERS).get();
    if (result.docs.length > 0) {
      const resultList = [...result.docs];
      const listCc = [];
      resultList.forEach((x) => {
        listCc.push({
          nickname: x.data().nickname,
          id: x.data().id,
          photoUrl: x.data().photoUrl,
          pushToken: x.data().pushToken,
        });
      });
      setListUsersFirebase(listCc ?? []);
    }
  };

  async function getListUserFirebaseData() {
    const result = await myFirestore.collection(AppString.NODE_USERS).get();
    if (result.docs.length > 0) {
      const resultList = [...result.docs];
      const listCc = [];
      resultList.forEach((x) => {
        listCc.push({
          nickname: x.data().nickname,
          id: x.data().id,
          photoUrl: x.data().photoUrl,
          pushToken: x.data().pushToken,
        });
      });
      return listCc;
    }
  };
  async function fetchCurrentUser() {
    //Save Last Message
    try {
      //fetch List
      const currentUserId = localStorage.getItem(AppString.ID);
      setUserId(currentUserId);
      const loads = await myFirestore
        .collection(AppString.NODE_LOADS)
        .where("shipperId", "==", currentUserId)
        .get();
      let data = [...loads.docs];
      const listLoads = [];
      data?.length > 0 && data.forEach((item) => {
        listLoads.push(item.data());
      });
      const item = listLoads?.find(s => s.id === props?.id);

      const listAllUsers = await getListUserFirebaseData();
      const peerItem = listAllUsers?.find(
        (x) => x.id === item?.userId
      );
        setPeerItem(peerItem);
      if(!!item){
        myFirestore
        .collection(AppString.NODE_LOADS)
        .doc(`${item?.id}-${item?.userId}-${item?.shipperId}`)
        .update({
          isReadWeb: true,
        })
        .then((data) => {
          console.log(data);
        });
        setTimeout(() => {
          setPerCurrentUsers(undefined);
          setPerCurrentUsers(item);
        }, 500);
      }
    } catch (err) {
      console.error("err", err);
    }
  }

  useEffect(() => {
   if(!!props?.id){
    getListUserFirebase();
    fetchCurrentUser();
   }
  }, [props]);

  return (
    <>
      <Modal
        show={props?.show}
        className="modal modal-sticky modal-sticky-bottom-right"
        role="dialog"
      >
        <Modal.Body>
          <div className="card card-custom">
            {/*begin::Header*/}
            <div className="card-header align-items-center px-4 py-3">
              {currentPeerItem?.photoUrl ? (
                <img
                  className="viewAvatarItem"
                  src={currentPeerItem?.photoUrl}
                  alt="icon avatar"
                />
              ) : (
                <div className="symbol symbol-20 symbol-lg-35 symbol-circle">
                  <span className="symbol-label bg-light-danger text-danger fs-6 font-weight-bolder">
                      {!!currentPeerItem && currentPeerItem.nickname?.length > 0 && Array.from(
                        currentPeerItem.nickname
                      )[0]
                      }
                  </span>
                </div>
              )}
              <div className="text-left flex-grow-1 ml-3">
                <div className="text-dark-75 font-weight-bold font-size-h5">
                  {currentPeerItem?.nickname}
                </div>
                <div>
                  <span className="font-weight-bold text-muted font-size-sm">
                    {`(Load#: ${props?.id})`}
                  </span>
                </div>
              </div>
              <div className="text-right flex-grow-1">
                <button
                  type="button"
                  className="btn btn-clean btn-sm btn-icon btn-icon-md"
                  data-dismiss="modal"
                  onClick={() => {
                    props.setShow(false);
                  }}
                >
                  <i className="ki ki-close icon-1x" />
                </button>
              </div>
            </div>
            {/*end::Header*/}
            {/*begin::Body*/}
            <div className="card-body">
              {/*begin::Scroll*/}
              <div
                className="scroll scroll-pull"
              >
                {/*begin::Messages*/}
                <div className="messages">
                  {!!currentPeerUser && !!userId  && !!currentPeerItem && (
                    <ChatBoardDetail
                      currentPeerUser={currentPeerUser}
                      showToast={true}
                      usersList={listUsersFirebase}
                      currentUserFirebase={currentPeerItem}
                    />
                  )}
                 
                  {/*end::Message Out*/}
                </div>
                {/*end::Messages*/}
              </div>
              {/*end::Scroll*/}
            </div>
            {/*end::Footer*/}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
